/* =========================================================
   EAZY CLOTHES — PRZYKLEJONY PASEK ZAKUPU (telefon)

   Pasek pokazuje sie wtedy i tylko wtedy, gdy PRAWDZIWY przycisk
   "Dodaj do koszyka" jest poza ekranem. Na karcie produktu przy
   390x844 przycisk stoi na y=865, czyli pod zagieciem — pasek jest
   wiec widoczny juz przy wejsciu na strone i znika, gdy klient
   doscrolluje do formularza.

   Pasek NIE duplikuje formularza. Nie ma wlasnego wariantu, wlasnej
   ilosci ani wlasnego zadania do /cart/add. Klikniecie przekazuje
   klikniecie do przycisku Savor, a cene i etykiete odczytuje z zywego
   DOM przy kazdej aktualizacji. Dzieki temu mechanika koszyka,
   wariantow i checkoutu zostaje nietknieta, a pasek nie moze sie
   rozjechac ze stanem formularza.

   Zadnych zapamietanych referencji do wezlow Savor: przy zmianie
   rozmiaru motyw przerenderowuje sekcje i podmienia formularz, wiec
   kazde odpytanie idzie do DOM od nowa.
   ========================================================= */
(function ezBuyBar() {
  const bar = document.querySelector('[data-ez-buy-bar]');
  if (!bar) return;

  const cta = bar.querySelector('[data-ez-buy-bar-cta]');
  const priceOutput = bar.querySelector('[data-ez-buy-bar-price]');
  if (!cta || !priceOutput) return;

  const FORM = '#MainContent form.shopify-product-form';
  const BUTTON = 'button[name="add"]';

  const findButton = () => {
    const form = document.querySelector(FORM);
    return form ? form.querySelector(BUTTON) : null;
  };

  /* Cena z tej samej sekcji co formularz. Karty produktow polecanych
     nizej na stronie tez maja <product-price>, wiec zawezenie do sekcji
     jest tu istotne, nie kosmetyczne. */
  const findPrice = (button) => {
    const scope = button.closest('.shopify-section');
    return scope ? scope.querySelector('product-price .price') : null;
  };

  let visible = false;
  let ticking = false;

  const setVisible = (next) => {
    if (next === visible) return;
    visible = next;
    bar.classList.toggle('is-visible', next);
  };

  const update = () => {
    ticking = false;

    const button = findButton();
    if (!button) {
      setVisible(false);
      return;
    }

    const rect = button.getBoundingClientRect();
    const buttonOnScreen = rect.bottom > 0 && rect.top < window.innerHeight;
    if (buttonOnScreen) {
      setVisible(false);
      return;
    }

    /* Etykieta idzie z przycisku Savor, wiec "Wyprzedane" i "Niedostepny"
       przychodza z jego wlasnych tlumaczen — bez powtarzania tu logiki
       zapasow z blocks/buy-buttons.liquid. */
    const label = button.querySelector('.add-to-cart-text__content');
    if (label) cta.textContent = label.textContent.trim();
    cta.disabled = button.disabled;

    const price = findPrice(button);
    if (price) priceOutput.textContent = price.textContent.trim();

    setVisible(true);
  };

  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  cta.addEventListener('click', () => {
    const button = findButton();
    if (!button || button.disabled) return;
    button.click();
  });

  /* Zapas pod stopka bierze sie z realnej wysokosci paska, nie ze
     zgadnietej liczby w CSS — pasek jest ukryty przez visibility, wiec
     nadal ma uklad i da sie go zmierzyc. */
  const syncHeight = () => {
    document.body.style.setProperty('--ez-buy-bar-height', `${bar.offsetHeight}px`);
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', () => {
    syncHeight();
    scheduleUpdate();
  });

  /* Rozmiar mozna zmienic, gdy pasek juz wisi — selektor wariantu stoi
     nad zagieciem, przycisk pod nim. Po zmianie Savor przerenderowuje
     sekcje, wiec cena i stan przycisku w pasku musza pojsc za tym. */
  const main = document.querySelector('#MainContent');
  if (main) {
    new MutationObserver(scheduleUpdate).observe(main, {
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'value'],
    });
  }

  /* Pasek zaslania dol strony, wiec stopka dostaje na telefonie zapas
     rowny jego wysokosci. Zapas tylko tam, gdzie pasek ma sie z czego
     wziac: karta bez formularza zakupu (np. egzemplarz Legit Check,
     ktoremu ktos przypisal zwykly szablon) nie dostaje go wcale. */
  if (findButton()) {
    document.body.classList.add('ez-has-buy-bar');
    syncHeight();
  }

  update();
})();
